import { useQuery } from "@apollo/client";
import { GET_WAREHOUSE } from "../apollo/queries";
import { getSelectedStoreDetails } from "../utils/helperFunctions";
import useFilters from "../core/hooks/useFilters";

const useWarehouse = () => {
  const {
    search,
    sort,
    debouncedValue,
    onChange,
    onChangeSort,
    pagination,
    handlePageChange,
  } = useFilters();
  const { loading, error, data, refetch } = useQuery(GET_WAREHOUSE, {
    variables: {
      input: {
        limit: pagination.limit,
        pageStart: pagination.pageStart,
        store_id: getSelectedStoreDetails("id"),
        name: debouncedValue,
        sort: sort?.value,
      },
    },
    fetchPolicy: "network-only",
  });

  if (error) {
    console.log("Error While Getting Brands", error);
  }

  console.log("useWarehouse");

  return {
    values: {
      allWarehouse: data?.allWarehouse || [],
      total: data?.allWarehouse?.total || 0,
      loading,
      search,
      sort,
      pageValues: {
        current: pagination.pageStart + 1,
        pageSize: pagination.limit,
        total: data?.allWarehouse?.total || 0,
      },
    },
    functions: {
      onChange,
      refetch,
      onChangeSort,
      handlePageChange,
    },
  };
};

export default useWarehouse;
